export default "__VITE_ASSET__aK8a3W_X__"